import { formatScores, useMatchData, composeAggregate } from "../../utils";
import React from "react";
import { d3AggregateAPI } from "../../../shared/api/variables";
import { useQuery } from "react-query";
import { fetchClient } from "../../../shared/api/fetching";
import { useReactAppState } from "../../../shared/containers/utils";

function MatchShootout() {
  const { apiList } = useReactAppState();
  const { d3SportsAPI } = apiList || {};
  const { homeClubData, awayClubData, period, resultType, queryConfig, matchOptaId, competition } = useMatchData();

  const d3AggregateEndpoint = d3AggregateAPI({ matchOptaId });
  const { data: aggregateData, isLoading } = useQuery({
    queryKey: [`d3-aggregate`, { matchOptaId }],
    queryFn: () => fetchClient({ endpoint: d3AggregateEndpoint, apiURL: d3SportsAPI }),
    ...queryConfig,
    enabled: !!(matchOptaId) && (competition?.optaId == 549 || (competition?.optaId == 98 && competition?.matchType === "Cup"))
  });

  const { aggregate, date } = aggregateData || {};

  const composedAggregate = composeAggregate(aggregate, date);

  const { shootoutResult } = formatScores({
    homeClubData,
    awayClubData,
    period,
    resultType
  });

  if (isLoading) {
    return null;
  }

  return (
    composedAggregate || shootoutResult
      ? <div className="mls-o-match-strip__shootout-description">{composedAggregate || shootoutResult}</div>
      : null
  );
}

export default MatchShootout;
